import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators'
import User from '../models/user'
import { firestore } from '../firebase'
import store from './'
import { eventStore } from './event-store'
import { foodStore } from './food-store'
import { orderStore } from './order-store'

const defaultUser = {
  id: '',
  name: '',
  photo: ''
}

@Module({ dynamic: true, store, name: 'user' })
export default class UserStore extends VuexModule {
  // state
  firstName = 'Foo';
  lastName = 'Bar';
  firebaseAuthStateLoaded = false
  loggedIn = false
  user: User = defaultUser
  vendorId = ''

  // getters
  get fullName () {
    return this.firstName + ' ' + this.lastName
  }

  // mutations
  // @Mutation
  // setFirstName (firstName: string) {
  //   this.firstName = firstName
  // }

  // @Mutation
  // setLastName (lastName: string) {
  //   this.lastName = lastName
  // }

  @Mutation
  setfirebaseAuthStateLoaded () {
    this.firebaseAuthStateLoaded = true
  }

  @Mutation
  setLoggedIn (user: User) {
    this.loggedIn = true
    this.user = user
  }

  @Mutation
  setUser (user: User) {
    this.user = user
  }

  @Mutation
  setLoggedOut () {
    this.loggedIn = false
    this.user = defaultUser
  }

  @Mutation
  setUserName (userName: string) {
    this.user.name = userName
  }

  @Mutation
  setVendorId (vendorId: string) {
    this.vendorId = vendorId
  }

  @Action
  async login (user: User) {
    this.setLoggedIn(user)

    // lookup the users vendor
    const vendorQuery = firestore.collection('vendors').where('owners', 'array-contains', user.id)
    const vendorQuerySnapshot = await vendorQuery.get()
    this.setVendorId(vendorQuerySnapshot.docs[0].id)

    eventStore.bindEvents()
    foodStore.bindFoodList()
    orderStore.bindOrders()
  }

  // actions
  @Action({ commit: 'setUser' })
  async loadUser () {
    // this.user.name = 'Bar' // Bad, the state is mutated outside a mutation
    return { ...this.user, name: 'ABar' } // OK! the entire object is updated (not mutated)
  }

  // @Action
  // async loadUser () {
  //   // const user = await fetchUser()\
  //   setTimeout(() => {
  //     const user = { firstName: 'Ted', lastName: 'Fred' }
  //     this.setFirstName(user.firstName)
  //     this.setLastName(user.lastName)
  //   }, 1000)
  // }
}

export const UserStoreMod = getModule(UserStore)
